import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate, useLocation } from "react-router";
import { Table, Badge, InputGroup, Alert, FormControl, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Spinner, OverlayTrigger, Tooltip, Modal, ToastContainer, Accordion } from 'react-bootstrap';

import { ArticleService } from '../../services/ArticleService';
import { FournisseurService } from '../../services/FournisseurService';
import { FactureService } from '../../services/FactureService';
import { BrouillonService } from '../../services/BrouillonService';
import { EditionService } from '../../services/EditionService';
import { ClientService } from '../../services/ClientService';
import { UsersProfilService } from '../../services/UsersProfilService';
import { PreferenceService } from '../../services/PreferenceService';


import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../components/pagination/Pagination';
import SideDetailsBrouillon from '../../components/side-details/SideDetailsBrouillon';
import FournisseurDetails from '../../components/side-details/fournisseur/fournisseur-details/FournisseurDetails';
import FournisseurEdition from '../../components/side-details/fournisseur/fournisseur-edition/FournisseurEdition';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../components/families/Families';
import { UserService } from '../../services/UserService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../services/GlobalProvider";
import { getFormErrorMsg, currencyFormat, granted, formattedDateInput, getInvalidObject, getFile } from '../../helper/Helper'
import DetailsTable from '../brouillon/details-table/DetailsTable'
import Reglements from './reglements/Reglements'
import Scheduled from './scheduled/Scheduled'
import Description from './description/Description'
import Observations from './observations/Observations'
import ClientNom from './client-nom/ClientNom'
import WysiwygInput from "../../components/form-inputs/wysiwyg-input/WysiwygInput";
import ClientInput from "../../components/form-inputs/client-input/ClientInput";

import ClientEdition from '../../components/side-details/client/client-edition/ClientEdition';
import ClientDetails from '../../components/side-details/client/client-details/ClientDetails';

import ArticleEdition from '../../components/side-details/article/article-edition/ArticleEdition';
import ArticleDetails from '../../components/side-details/article/article-details/ArticleDetails';

import ModalValidation from './modal-validation/ModalValidation';
import SecteurAnalytique from './secteur-analytique/SecteurAnalytique';


import './Brouillon.scss';

export default function Brouillon() {

    const navigate = useNavigate();

    const location = useLocation();

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences, userDetails } = React.useContext(GlobalContext);

    const [searchParams, setSearchParams] = useSearchParams();
    const [confirmDialog, setConfirmDialog] = useState({ show: false, dialogInfos: null })
    const [currentBrouillon, setCurrentBrouillon] = useState();
    const [modifiedValues, setModifiedValues] = useState();
    const [showChanges, setShowChanges] = useState(false);
    const [invalidData, setInvalidData] = useState()
    const [globalError, setGlobalError] = useState()
    const [isSaving, setIsSaving] = useState(false)
    const [isValidateLoading, setIsValidateLoading] = useState(false)
    const [getBrouillonLoading, setGetBrouillonLoading] = useState(false)

    const [clientComptant, setClientComptant] = useState()
    const [isAccordeonOpen, setIsAccordeonOpen] = useState(true)
    const [profilsFolderUsers, setProfilsFolderUsers] = useState()

    const [isClientCreateOpen, setIsClientCreateOpen] = useState(false)

    const [isClientDetailOpen, setIsClientDetailOpen] = useState(false)
    const [isClientEditing, setIsClientEditing] = useState(false)
    const [clientElementActions] = useState([])

    const [articleDetailOpenId, setArticleDetailOpenId] = useState()
    const [isArticleEditing, setIsArticleEditing] = useState(false)
    const [isDetailsEditing, setIsDetailsEditing] = useState(false)
    const [isScheduledEditing, setIsScheduledEditing] = useState(false)
    const [isObservationsEditing, setIsObservationsEditing] = useState(false)
    const [isClientNomEditing, setIsClientNomEditing] = useState(false)
    const [articleElementActions] = useState([])

    const brouillonId = searchParams.get('brouillonId') ? searchParams.get('brouillonId') : null
    const createdFrom = searchParams.get('from') ? searchParams.get('from') : ""

    const [showModalValidation, setShowModalValidation] = useState({ show: false, postValidateResponse: null })

    let typeInPath = location.pathname.split("/")[2];

    useEffect(() => {
        if (grants) {
            granted(grants, "clients.edit") && clientElementActions.push({ icon: "edit", title: "Modifier le client", action: "editClient" })
            granted(grants, "articles.edit") && articleElementActions.push({ icon: "edit", title: "Modifier l'article", action: "editArticle" })
        }
    }, [grants]);

    useEffect(() => {
        if (globalContextLoaded) {
            getBrouillon()
            getFolderUsers()
        }
    }, [globalContextLoaded]);

    useEffect(() => {
        if (currentBrouillon && (currentBrouillon.type != "facture_abonnement") && (currentBrouillon.type != "abonnement") && parametres?.brouillons?.comptant_default) {
            getClientComptant()
        }

        if (currentBrouillon != null) { // Ajouter le brouillon en cours dans les préférences

            if (currentBrouillon.type == "facture" || currentBrouillon.type == "avoir") {
                PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['factures']: { ["currentDraft"]: currentBrouillon._id } } }).then(res => {
                    getPreferences()
                }).catch(error => {
                    setGlobalError(error)
                });
            }
            if (currentBrouillon.type == "proforma") {
                PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['proformas']: { ["currentDraft"]: currentBrouillon._id } } }).then(res => {
                    getPreferences()
                }).catch(error => {
                    setGlobalError(error)
                });
            }
            if (currentBrouillon.type == "abonnement") {
                PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['abonnements']: { ["currentDraft"]: currentBrouillon._id } } }).then(res => {
                    getPreferences()
                }).catch(error => {
                    setGlobalError(error)
                });
            }
        }
    }, [currentBrouillon != null]); // Evite de relancer à chaque changement de currentBrouillon

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    function removeCurrentDraftPreferenceAndRedirect(redirect, idDocument) {
        if (typeInPath == "factures") {
            PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['factures']: { ["currentDraft"]: "" } } }).then(res => {
                if (redirect) {
                    preferences.factures.currentDraft = ""
                    getPreferences()
                    navigate(`/${folderDetails?.dossier?._id}/factures?${idDocument ? ('factureId=' + idDocument) : ""}`)
                }
            }).catch(error => {
                setGlobalError(error)
            });

        }
        if (typeInPath == "proformas") {
            PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['proformas']: { ["currentDraft"]: "" } } }).then(res => {
                if (redirect) {
                    preferences.proformas.currentDraft = ""
                    getPreferences()
                    navigate(`/${folderDetails?.dossier?._id}/proformas?${idDocument ? ('proformaId=' + idDocument) : ""}`)
                }
            }).catch(error => {
                setGlobalError(error)
            });
        }
        if (typeInPath == "abonnements") {
            PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['abonnements']: { ["currentDraft"]: "" } } }).then(res => {
                if (redirect) {
                    preferences.abonnements.currentDraft = ""
                    getPreferences()
                    navigate(`/${folderDetails?.dossier?._id}/abonnements?${idDocument ? ('abonnementId=' + idDocument) : ""}`)
                }
            }).catch(error => {
                setGlobalError(error)
            });
        }
    }

    function getBrouillon() {
        setGetBrouillonLoading(true)
        BrouillonService.getBrouillon(folderDetails?.dossier?._id, brouillonId).then(res => {
            setGetBrouillonLoading(false)
            res.status !== 200 && setGlobalError({ statusText: `Ce brouillon n'a pas été trouvé (${res.statusText})` })
            if (res.status !== 200) {
                setGlobalError({ statusText: `Ce brouillon n'a pas été trouvé (${res.statusText})` })
                if (brouillonId == preferences[typeInPath].currentDraft) {
                    removeCurrentDraftPreferenceAndRedirect(true)
                }
            }
            setCurrentBrouillon(res.data.data)
            setModifiedValues(res.data.data?.modifiedValues)
        }).catch(error => {
            removeCurrentDraftPreferenceAndRedirect(true)
            setGetBrouillonLoading(false)
        });
    }

    function postCheckBrouillon() {
        BrouillonService.postCheckBrouillon(folderDetails?.dossier?._id, brouillonId).then(res => {
            res.status !== 200 && setGlobalError({ statusText: `Ce brouillon n'a pas été trouvé (${res.statusText})` })
            getBrouillon()
        }).catch(error => {
            setGlobalError(error)
        });
    }

    function updateBrouillonData(data) {
        data['_id'] = currentBrouillon._id
        setIsSaving(true)
        BrouillonService.updateBrouillon(folderDetails?.dossier?._id, { "brouillons": [data] }).then(res => {
            setIsSaving(false)
            getBrouillon()
        }).catch(error => {
            setGlobalError(error)
            setInvalidData(getInvalidObject(error.data?.data))
            setIsSaving(false)
        });
    }

    function postValidate() {
        setIsValidateLoading(true)
        BrouillonService.postValidate(folderDetails?.dossier?._id, currentBrouillon._id).then(res => {

            /* SI le document est de type facture_abonnement, on ferme : */

            if (currentBrouillon.type == "abonnement") {
                const responseIdDocument = Object.keys(res.data.data[currentBrouillon.type])[0]
                let idDocument = res.data.data[currentBrouillon.type][responseIdDocument]["abonnement"][0]
                removeCurrentDraftPreferenceAndRedirect(true, idDocument)
                return
            }

            if (currentBrouillon.type == "facture_abonnement") {
                const responseIdDocument = Object.keys(res.data.data[currentBrouillon.type])[0]
                let idDocument = res.data.data[currentBrouillon.type][responseIdDocument]["facture"][0]
                removeCurrentDraftPreferenceAndRedirect(true, idDocument)
                return
            }

            setShowModalValidation({ show: true, postValidateResponse: res })
            setIsValidateLoading(false)
        }).catch(error => {
            setGlobalError(error)
            setIsValidateLoading(false)
        });
    }

    function downloadDraftPDF() {
        EditionService.getBrouillon(folderDetails?.dossier?._id, currentBrouillon._id, "pdf").then(res => {
            if (!res.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                getFile(res)
            }
        }).catch(error => {
            setGlobalError(error)
        });
    }

    function getClientComptant() {
        let clientComptantId = parametres?.brouillons?.comptant_default
        ClientService.getClient(folderDetails?.dossier?._id, clientComptantId).then(res => {
            setClientComptant(res.data.data)
        }).catch(error => {
            setClientComptant()
            //setGlobalError(error)
        });
    }

    function getFolderUsers() {
        if (granted(grants, "brouillons.edit.vendeur")) {
            UsersProfilService.getUsersProfilsFolderUsers(folderDetails?.dossier?._id).then(res => {
                setProfilsFolderUsers(res.data.data)
            }).catch(error => {
                setGlobalError(error)
            });
        }
    }

    function handleChange(e) {
        updateBrouillonData({
            [e.target.name]: e.target.value
        })
        setInvalidData({ ...invalidData, [e.target.name]: null })

    }

    function handleChangeAdresse(e) {
        updateBrouillonData({
            [e.target.name]: {
                adresse_id: e.target.value
            }
        })
        setInvalidData({ ...invalidData, [e.target.name]: null })
    }

    function handleChangeVendeur(e) {
        updateBrouillonData({
            ['vendeur']: e.target.value
        })
        setInvalidData({ ...invalidData, [e.target.name]: null })
    }

    function changeClient(c) {
        updateBrouillonData({
            ['client_id']: c?._id ? c?._id : "",
            ['client_nom']: "",
            ['adresse_facturation']: {
                ['adresse_id']: ""
            },
            ['adresse_livraison']: {
                ['adresse_id']: ""
            }
        })
        setInvalidData({ ...invalidData, ['client_id']: null })
    }

    function closeBrouillon() {
        if (currentBrouillon.type == "facture_abonnement") {
            window.close();
        }
        PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { [typeInPath]: { ["currentDraft"]: "" } } }).then(res => {
            preferences[typeInPath].currentDraft = ""
            getPreferences()
            navigate(`/${folderDetails?.dossier?._id}/${createdFrom}`)
        }).catch(error => {
            setGlobalError(error)
        });
    }

    function handleKeyDown(e) {
        const { code } = e;
        switch (code) {
            case "F10":
                changeClient(clientComptant)
                e.preventDefault();
                break;
            case "ctrlKey":
                break;
            default:
                break;
        }
    }

    function getReglementStatus() {

        if (currentBrouillon.details.length > 0) {
            if (currentBrouillon?.reglements?.reste_a_payer <= 0) {
                return <Badge pill bg="success" text="white" className="ms-2 fs-6 d-flex flex-row"><i className="material-icons me-1">credit_card</i>Réglée</Badge>
            }
            if (currentBrouillon?.reglements?.reste_a_payer == currentBrouillon?.reglements?.net_a_payer) {
                return <Badge pill bg="danger" text="white" className="ms-2 fs-6 d-flex flex-row"><i className="material-icons me-1">credit_card</i>Non réglée</Badge>
            }
            if (currentBrouillon?.reglements?.total_reglements != 0 && (currentBrouillon?.reglements?.total_reglements < currentBrouillon?.reglements?.net_a_payer)) {
                return <Badge pill bg="warning" text="dark" className="ms-2 fs-6 d-flex flex-row"><i className="material-icons me-1">credit_card</i>Partiellement réglée</Badge>
            }
        } else {
            return null
        }

    }

    function removeBrouillonDialog() {
        setConfirmDialog({
            show: true,
            dialogInfos: {
                title: `Annuler le brouillon`,
                description: `Voulez vous annuler le brouillon ${currentBrouillon.code} ?`,
                actionName: 'Annuler le brouillon',
                btnVariant: 'danger',
                element: currentBrouillon._id,
                error: false,
                confirmAction: 'removeBrouillon'
            }
        })
    }

    function removeBrouillon() {
        BrouillonService.removeBrouillon(folderDetails?.dossier?._id, currentBrouillon._id).then(res => {
            setConfirmDialog({ show: false })
            closeBrouillon()
        }).catch(error => {
            setGlobalError(error)
            setConfirmDialog({ show: false })
        });
    }

    function closeSide() {
        setIsClientCreateOpen(false)
        setIsClientEditing(false)
        setIsClientDetailOpen(false)
        setIsArticleEditing(false)
        setArticleDetailOpenId()
        getBrouillon()
    }

    function onClientCreateSaved(clientId) {
        changeClient({ _id: clientId })
        setIsClientCreateOpen(false)
    }

    function onArticleSaved() {
        setIsArticleEditing(false)
        setArticleDetailOpenId()
        postCheckBrouillon()
    }

    function editClient() {
        setIsClientEditing(true)
    }

    function editArticle() {
        setIsArticleEditing(true)
    }

    return (
        <>
            {isSaving &&
                <span className="position-fixed rounded shadow-lg bottom-0 end-0 zindex-9000 px-4 py-2 m-5 bg-gray-700 text-white">
                    Enregistrement
                    <Spinner size="sm" animation="border" className="ms-2" />
                </span>
            }

            {showModalValidation.show && <ModalValidation postValidateResponse={showModalValidation?.postValidateResponse} currentBrouillon={currentBrouillon} setClose={(idDocument) => removeCurrentDraftPreferenceAndRedirect(true, idDocument)} />}

            <ConfirmDialog
                show={confirmDialog.show}
                dialogInfos={confirmDialog.dialogInfos}
                setCancel={() => setConfirmDialog({ show: false })}
                setConfirm={(a, e) => eval(a)(e)}
            />

            {/* Panneau de détails à droite */}

            {isClientCreateOpen &&
                <SideDetailsBrouillon
                    editMode={true}
                    setSideClose={closeSide}
                    setSideCancel={closeSide}
                    detailsComponent={
                        <ClientEdition folderId={folderDetails?.dossier?._id} onSetSaved={(clientId) => onClientCreateSaved(clientId)} />
                    }
                />
            }
            {isClientDetailOpen &&
                <SideDetailsBrouillon
                    editMode={isClientEditing}
                    setSideClose={closeSide}
                    setSideCancel={closeSide}
                    detailsComponent={
                        isClientEditing ?
                            <ClientEdition folderId={folderDetails?.dossier?._id} clientEditingId={currentBrouillon.client_id} onSetSaved={closeSide} />
                            :
                            <ClientDetails folderId={folderDetails?.dossier?._id} clientId={currentBrouillon.client_id} elementActions={clientElementActions} setElementAction={(a, e) => eval(a)(e)} onTabChange={() => { return }} />
                    }
                />
            }
            {articleDetailOpenId &&
                <SideDetailsBrouillon
                    editMode={isArticleEditing}
                    setSideClose={closeSide}
                    setSideCancel={closeSide}
                    detailsComponent={
                        isArticleEditing ?
                            <ArticleEdition folderId={folderDetails?.dossier?._id} articleEditingId={articleDetailOpenId} onSetSaved={onArticleSaved} />
                            :
                            <ArticleDetails folderId={folderDetails?.dossier?._id} articleId={articleDetailOpenId} elementActions={articleElementActions} setElementAction={(a, e) => eval(a)(e)} onTabChange={() => { return }} />
                    }
                />
            }

            <div id="Brouillon">
                <>

                    {globalError && (
                        <ErrorManager error={globalError} fixed="true" />
                    )}

                    {currentBrouillon &&
                        <Container fluid className="border-bottom  ps-0">
                            <Row className="  ">
                                <Col xs="auto" className="d-flex align-items-center text-white bg-gray-900 ps-4 pe-4 py-2">
                                    <h4 className="m-0 p-0 text-uppercase"><i className="float-start material-icons me-2">receipt_long</i>BROUILLON : {currentBrouillon.type} {currentBrouillon.code}</h4>
                                </Col>
                                <Col className="py-3">
                                    <Row>
                                        <Col xs={12} xl={6} className="d-flex order-2 order-xl-1 align-items-center ps-3 ">
                                            {/* <Badge pill bg="dark" text="white" className="fs-6 d-flex flex-row"><i className="material-icons me-1">receipt_long</i>{currentBrouillon.type} {currentBrouillon.code}</Badge> */}
                                            <Badge pill bg="gray-200" text="dark" className="ms-2 fs-6 d-flex flex-row">
                                                <i className="material-icons me-1">account_balance_wallet</i>
                                                <span className={(showChanges && modifiedValues?.statut) ? "modified-bg " : ""}>
                                                    {currentBrouillon.statut == "debit" && "Débit"}
                                                    {currentBrouillon.statut == "comptant" && "Comptant"}
                                                    {currentBrouillon.statut == "interne" && "Interne"}
                                                </span>
                                            </Badge>
                                            <Badge pill bg="gray-200" text="dark" className="ms-2 fs-6 d-flex flex-row">
                                                <i className="material-icons me-1">event</i>
                                                <><span className="text-capitalize me-1">{currentBrouillon.type}</span>du {new Date(currentBrouillon.date).toLocaleString()}</>
                                            </Badge>

                                            {currentBrouillon.type == "facture" && getReglementStatus()}


                                            <Form.Check
                                                className="ms-3"
                                                type="switch"
                                                label="Surligner les changements"
                                                id="disabled-custom-switch"
                                                checked={showChanges}
                                                onChange={() => setShowChanges(!showChanges)}
                                            />


                                        </Col>
                                        <Col xs={12} xl={6} className="d-flex order-1 order-xl-2 align-items-center pb-2 pb-xxl-0">
                                            <div className="d-flex align-items-center ms-3 ms-xl-auto">
                                                {granted(grants, "brouillons.edit.vendeur") &&
                                                    <>
                                                        <span className="me-2">Vendeur : </span>
                                                        {profilsFolderUsers?.length > 0 ?
                                                            <Form.Group className="d-flex">
                                                                <Form.Select name="profil" defaultValue={currentBrouillon?.vendeur} onChange={handleChangeVendeur}>
                                                                    {profilsFolderUsers.map(profil =>
                                                                        <option key={profil.user} value={profil.user}>{profil.user}</option>
                                                                    )}
                                                                </Form.Select>
                                                            </Form.Group>
                                                            :
                                                            <em>- Aucun profil trouvé -</em>
                                                        }
                                                    </>
                                                }

                                                <Dropdown className="ms-3 float-end">
                                                    <OverlayTrigger
                                                        delay={{ show: 800 }}
                                                        overlay={
                                                            <Tooltip>
                                                                Plus d'actions
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Dropdown.Toggle variant="secondary" className='no-btn-caret'>
                                                            <i className="material-icons i-lg">more_horiz</i>
                                                        </Dropdown.Toggle>
                                                    </OverlayTrigger>
                                                    <Dropdown.Menu>
                                                        {currentBrouillon.type !== "abonnement" &&
                                                            <Dropdown.Item disabled={!currentBrouillon.client_id} onClick={downloadDraftPDF}>Imprimer le brouillon</Dropdown.Item>
                                                        }
                                                        {/* Si c'est le brouillon de l'utilisateur connecté et qu'il a les droits */}
                                                        {/* Si c'est le brouillon d'un autre utilisateur et que l'utilisateur connecté a les droits */}
                                                        {((currentBrouillon.user == userDetails.preferred_username) && (granted(grants, "brouillons.remove"))) &&
                                                            <Dropdown.Item className="text-danger" onClick={() => removeBrouillonDialog()}>Annuler</Dropdown.Item>
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>

                                                <Button className="ms-2" variant="secondary" onClick={closeBrouillon}>Fermer</Button>

                                                {currentBrouillon.type == "facture_abonnement" &&
                                                    <Button
                                                        className="ms-2"
                                                        onClick={postValidate}
                                                        disabled={isValidateLoading || isSaving || !currentBrouillon.client_id || !currentBrouillon.vendeur || currentBrouillon.details.length == 0 || isDetailsEditing || isObservationsEditing || isScheduledEditing || isClientNomEditing}
                                                    >
                                                        {isValidateLoading && <Spinner animation="border" size="sm" className="me-2" />}
                                                        Valider la facture d'abonnemment
                                                    </Button>
                                                }
                                                {currentBrouillon.type == "facture" &&
                                                    <Button
                                                        className="ms-2"
                                                        onClick={postValidate}
                                                        disabled={isValidateLoading || isSaving || !currentBrouillon.client_id || !currentBrouillon.vendeur || currentBrouillon.details.length == 0 || isDetailsEditing || isObservationsEditing || isScheduledEditing || isClientNomEditing}
                                                    >
                                                        {isValidateLoading && <Spinner animation="border" size="sm" className="me-2" />}
                                                        Valider la facture
                                                    </Button>
                                                }
                                                {currentBrouillon.type == "proforma" &&
                                                    <Button
                                                        className="ms-2"
                                                        onClick={postValidate}
                                                        disabled={isValidateLoading || isSaving || !currentBrouillon.client_id || !currentBrouillon.vendeur || currentBrouillon.details.length == 0 || isDetailsEditing || isObservationsEditing || isScheduledEditing || isClientNomEditing}
                                                    >
                                                        {isValidateLoading && <Spinner animation="border" size="sm" className="me-2" />}
                                                        Valider la proforma
                                                    </Button>
                                                }
                                                {currentBrouillon.type == "avoir" &&
                                                    <Button
                                                        className="ms-2"
                                                        onClick={postValidate}
                                                        disabled={isValidateLoading || isSaving || !currentBrouillon.client_id || !currentBrouillon.vendeur || currentBrouillon.details.length == 0 || isDetailsEditing || isObservationsEditing || isScheduledEditing || isClientNomEditing}
                                                    >
                                                        {isValidateLoading && <Spinner animation="border" size="sm" className="me-2" />}
                                                        Valider l'avoir
                                                    </Button>
                                                }
                                                {currentBrouillon.type == "abonnement" &&
                                                    <Button
                                                        className="ms-2"
                                                        onClick={postValidate}
                                                        disabled={isValidateLoading || isSaving || !currentBrouillon.client_id || !currentBrouillon.vendeur || currentBrouillon.details.length == 0 || isDetailsEditing || isObservationsEditing || isScheduledEditing || isClientNomEditing}
                                                    >
                                                        {isValidateLoading && <Spinner animation="border" size="sm" className="me-2" />}
                                                        Valider l'abonnement
                                                    </Button>
                                                }
                                            </div>
                                        </Col>
                                    </Row>



                                </Col>
                            </Row>
                        </Container>
                    }

                    {currentBrouillon &&
                        <Container fluid className="py-4">


                            {/* Zone infos header accordeon */}
                            <Row className="mb-3">

                                <Accordion defaultActiveKey="headerKey">
                                    <Accordion.Item eventKey="headerKey">

                                        <Accordion.Header onClick={() => { setIsAccordeonOpen(!isAccordeonOpen) }}>
                                            {isAccordeonOpen ?
                                                <>
                                                    <i className="me-1 fs-4 material-icons">info</i>Informations
                                                </>
                                                :
                                                <>
                                                    <span className="d-flex align-items-center w-100">

                                                        <Row className="w-100">
                                                            <Col xs={12} xl={"auto"} className="d-flex align-items-center">
                                                                {currentBrouillon?.client_nom &&
                                                                    <h6 className="text-dark d-flex align-items-center m-0 me-4"><i className="text-primary-600 me-1 fs-4 material-icons">person_outline</i>{currentBrouillon.client_nom}</h6>
                                                                }
                                                                {currentBrouillon?.date_execution &&
                                                                    <h6 className="text-dark d-flex align-items-center m-0 me-4"><i className="text-primary-600 me-1 fs-4 material-icons">event</i><span className="d-none d-xl-block me-2">Exécution le</span>{formattedDateInput(currentBrouillon.date_execution)}</h6>
                                                                }
                                                                {currentBrouillon?.observation &&
                                                                    <h6 className="text-dark d-flex align-items-center m-0 me-4"><i className="text-primary-600 me-1 fs-4 material-icons">notes</i>Observations</h6>
                                                                }
                                                            </Col>
                                                            <Col xs={12} xl={7} className="d-flex align-items-center ms-xl-auto">
                                                                <Row className="w-100">
                                                                    <Col xs={{ span: 4, offset: ((currentBrouillon?.type == "proforma" || currentBrouillon?.type == "abonnement") ? 4 : 0) }}>
                                                                        <span className="d-flex align-items-center px-2 w-100 d-flex bg-primary-700 text-light rounded ms-xl-2"><i className="me-1 fs-4 material-icons">receipt_long</i><span className="d-none d-lg-block me-2">Total TTC :</span> {currencyFormat(currentBrouillon.total_ttc)} {parametres?.general?.devise_dossier}</span>
                                                                    </Col>
                                                                    <Col xs={4}>
                                                                        <span className="d-flex align-items-center px-2 w-100 d-flex bg-primary-600 text-light rounded ms-2"><i className="me-1 fs-4 material-icons">bar_chart</i><span className="d-none d-lg-block me-2">Total prix de revient :</span> {currencyFormat(currentBrouillon.total_prix_revient)} {parametres?.general?.devise_dossier}</span>
                                                                    </Col>
                                                                    {currentBrouillon.type == "avoir" &&
                                                                        <Col xs={4} >
                                                                            <span className="d-flex align-items-center px-2 w-100 d-flex bg-primary-500 text-light rounded ms-2">
                                                                                <i className="me-1 fs-4 material-icons">credit_card</i>
                                                                                {currentBrouillon.reglements.reglements.length} remboursement(s)
                                                                            </span>
                                                                        </Col>
                                                                    }
                                                                    {currentBrouillon.type == "facture" &&
                                                                        <Col xs={4} >
                                                                            <span className="d-flex align-items-center px-2 w-100 d-flex bg-primary-500 text-light rounded ms-2">
                                                                                <i className="me-1 fs-4 material-icons">credit_card</i>
                                                                                {currentBrouillon.reglements.reglements.length} règlement(s)<span className="d-none d-xl-block"></span>
                                                                            </span>
                                                                        </Col>
                                                                    }
                                                                </Row>

                                                            </Col>
                                                        </Row>
                                                    </span>
                                                </>
                                            }
                                        </Accordion.Header>

                                        <Accordion.Body className="p-0">
                                            <Row>
                                                <Col xs={12} xl={currentBrouillon?.type == "proforma" ? { span: 6 } : { span: 4 }} xxl={5} className="order-2 order-xl-1 pe-0 mb-3 mb-xxl-0">
                                                    <Row className="p-3">
                                                        <Col sm={6} xl={currentBrouillon?.type == "proforma" ? { span: 6 } : { span: 12 }} xxl={6}>
                                                            <div className={(showChanges && modifiedValues?.client_id) ? "modified-border" : ""}>
                                                                <div className="d-flex align-items-center mb-2 justify-content-between">
                                                                    <h6 className="text-dark d-flex align-items-center m-0"><i className="text-primary-600 me-1 fs-4 material-icons">person_outline</i>Client<span className="text-danger">*</span></h6>
                                                                    {granted(grants, "clients.edit") &&
                                                                        <Button variant="link" className="p-0" onClick={() => setIsClientCreateOpen(true)}>Créer un client</Button>
                                                                    }
                                                                </div>
                                                                <div className="d-flex align-items-start mb-3">
                                                                    <div className="w-100">
                                                                        <ClientInput autoFocus disabled={currentBrouillon.type == "facture_abonnement" || ((currentBrouillon.type !== "proforma") && currentBrouillon.code)} clientId={currentBrouillon.client_id} clientComptant={clientComptant} clientComptantButton={clientComptant ? "true" : "false"} /* isInvalid={getFormErrorMsg(invalidData?.client_id)} */ folderId={folderDetails?.dossier?._id} setClient={c => changeClient(c)} />
                                                                    </div>

                                                                    {currentBrouillon.client_nom &&
                                                                        <OverlayTrigger
                                                                            delay={{ show: 800 }}
                                                                            overlay={
                                                                                <Tooltip>
                                                                                    Consulter
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <Button className="ms-2" variant="secondary" onClick={() => setIsClientDetailOpen(true)} >
                                                                                <i className="material-icons i-lg">exit_to_app</i>
                                                                            </Button>
                                                                        </OverlayTrigger>
                                                                    }

                                                                </div>

                                                                {currentBrouillon.client &&

                                                                    <>
                                                                        {currentBrouillon.client.type == "comptant" &&
                                                                            <ClientNom brouillon={currentBrouillon} changeValue={handleChange} setIsComponentEditing={value => setIsClientNomEditing(value)} invalidData={invalidData?.client_nom} showChanges={showChanges} modifiedValues={modifiedValues} />
                                                                        }

                                                                        <div className="mt-2">
                                                                            {(currentBrouillon.client.type == "debit") &&
                                                                                <>

                                                                                    <h6 className="text-dark d-flex align-items-center mb-2 mt-3"><i className="text-primary-600 me-1 fs-4 material-icons">location_pin</i>Adresses</h6>
                                                                                    {currentBrouillon?.client?.adresses?.length > 0 &&
                                                                                        <>
                                                                                            <Form.Group className="mb-2">
                                                                                                <Form.Label>Adresse de facturation :</Form.Label>
                                                                                                <Form.Select disabled={currentBrouillon?.client?.adresses?.length < 2} name="adresse_facturation" defaultValue={currentBrouillon.adresse_facturation?.adresse_id || ""} onChange={handleChangeAdresse}>
                                                                                                    {currentBrouillon?.client?.adresses?.length >= 2 &&
                                                                                                        <option value="" disabled>- Choisir -</option>
                                                                                                    }
                                                                                                    {currentBrouillon.client.adresses?.map(adresse =>
                                                                                                        <option key={adresse._id} value={adresse._id}>{adresse.libelle || adresse.adresse}</option>
                                                                                                    )}
                                                                                                </Form.Select>
                                                                                            </Form.Group>

                                                                                            <Form.Group>
                                                                                                <Form.Label>Adresse de livraison :</Form.Label>
                                                                                                <Form.Select disabled={currentBrouillon?.client?.adresses?.length < 2} name="adresse_livraison" defaultValue={currentBrouillon.adresse_livraison?.adresse_id || ""} onChange={handleChangeAdresse}>
                                                                                                    {currentBrouillon?.client?.adresses?.length >= 2 &&
                                                                                                        <option value="" disabled>- Choisir -</option>
                                                                                                    }
                                                                                                    {currentBrouillon.client.adresses?.map(adresse =>
                                                                                                        <option key={adresse._id} value={adresse._id}>{adresse.libelle || adresse.adresse}</option>
                                                                                                    )}
                                                                                                </Form.Select>
                                                                                            </Form.Group>
                                                                                        </>
                                                                                    }
                                                                                    {currentBrouillon?.client?.adresses?.length == 0 &&
                                                                                        <em>- Aucune adresse enregistrée -</em>
                                                                                    }

                                                                                    {(currentBrouillon?.client?.adresses?.length == 0 && currentBrouillon?.client?.type == "debit") &&
                                                                                        <Alert className="mt-3" variant="warning">
                                                                                            <h6>Adresse obligatoire</h6>
                                                                                            <p>Pour valider le brouillon, l'adresse est obligatoire sur les clients de type "debit".</p>
                                                                                            {granted(grants, "clients.edit") &&
                                                                                                <Button className="d-flex" variant="secondary" onClick={() => setIsClientDetailOpen(true)} >
                                                                                                    Ajouter une adresse
                                                                                                    <i className="ms-2 material-icons i-lg">exit_to_app</i>
                                                                                                </Button>
                                                                                            }
                                                                                        </Alert>
                                                                                    }


                                                                                </>
                                                                            }

                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col sm={6} xl={currentBrouillon?.type == "proforma" ? { span: 6 } : { span: 12 }} xxl={6}>
                                                            <div className={"mb-3 mt-xl-3 mt-xxl-0 " + ((showChanges && modifiedValues?.date_execution) ? "modified-border" : "")}>
                                                                <h6 className="text-dark d-flex align-items-center mb-2"><i className="text-primary-600 me-1 fs-4 material-icons">event</i>Date d'exécution</h6>
                                                                <Form.Group>
                                                                    <Form.Control name="date_execution" placeholder="Date d'exécution" value={formattedDateInput(currentBrouillon.date_execution)} onChange={handleChange} type="date" />
                                                                </Form.Group>
                                                            </div>
                                                            <div className="mb-3">
                                                                <Observations brouillon={currentBrouillon} changeValue={handleChange} setIsComponentEditing={value => setIsObservationsEditing(value)} invalidData={invalidData?.observation} showChanges={showChanges} modifiedValues={modifiedValues} />
                                                            </div>
                                                                {currentBrouillon?.mention_calc?.exoneration &&
                                                                    <>
                                                                        <h6 className="text-dark d-flex align-items-center mb-2"><i className="text-primary-600 me-1 fs-4 material-icons">block</i>Exonération</h6>
                                                                        <p>{currentBrouillon.mention_calc.exoneration}</p>
                                                                    </>
                                                                }
                                                                {currentBrouillon?.mention_calc?.historique &&
                                                                    <>
                                                                        <h6 className="text-dark d-flex align-items-center mb-2"><i className="text-primary-600 me-1 fs-4 material-icons">history_toggle_off</i>Historique</h6>
                                                                        <p>{currentBrouillon.mention_calc.historique}</p>
                                                                    </>
                                                                }
                                                            {parametres?.general?.export_comptable.comptabilite_analytique &&
                                                                <SecteurAnalytique value={currentBrouillon.secteur_analytique} setSecteur={s => handleChange(s)} name="secteur_analytique" isInvalid={getFormErrorMsg(invalidData?.secteur_analytique)} feedback={getFormErrorMsg(invalidData?.secteur_analytique)} />
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={12} xl={currentBrouillon?.type == "proforma" ? { span: 6 } : { span: 8 }} xxl={7} className="order-1 order-xl-2 ps-xxl-0">
                                                    <Row className="m-0 h-100">

                                                        <Col lg={currentBrouillon?.type == "proforma" ? { span: 6 } : null} xxl={currentBrouillon?.type == "proforma" ? { span: 4, offset: 4 } : null} className="bg-primary-700 text-white">
                                                            <div className="p-3">
                                                                <h6 className="d-flex align-items-center mb-2 text-capitalize"><i className="me-1 fs-4 material-icons">insert_drive_file</i>{currentBrouillon.type}</h6>
                                                                <div className="d-flex flex-column">
                                                                    {currentBrouillon.details.length == 0 &&
                                                                        <em>- Aucun total à afficher -</em>
                                                                    }
                                                                    {currentBrouillon.details.length > 0 &&
                                                                        <>

                                                                            {currentBrouillon.total_brut_ht != null &&
                                                                                <p className="m-0">
                                                                                    Total brut HT
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.total_brut_ht) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.total_brut_ht)} {parametres?.general?.devise_dossier}
                                                                                    </span>
                                                                                </p>
                                                                            }

                                                                            {currentBrouillon.total_remise != 0 &&
                                                                                <p className="m-0">
                                                                                    Total des remises
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.total_remise) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.total_remise)} {parametres?.general?.devise_dossier}
                                                                                    </span>
                                                                                </p>
                                                                            }

                                                                            {currentBrouillon.total_net_ht != null &&
                                                                                <p className="m-0">
                                                                                    Total net HT
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.total_net_ht) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.total_net_ht)} {parametres?.general?.devise_dossier}
                                                                                    </span>
                                                                                </p>
                                                                            }

                                                                            {currentBrouillon.total_taxes?.montant_total != null &&
                                                                                <p className="m-0">
                                                                                    Total DES TAXES
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.total_taxes?.montant_total) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.total_taxes?.montant_total)} {parametres?.general?.devise_dossier}
                                                                                    </span>
                                                                                </p>
                                                                            }

                                                                            {currentBrouillon.total_taxes?.montants_details != null &&
                                                                                <div className="border-start ms-0 text-primary-200 border-primary-300 me-1">
                                                                                    {currentBrouillon.total_taxes.montants_details.map(montant => (
                                                                                        <p key={montant.contribution_id} className="ms-2 my-0">
                                                                                            Dont {montant.libelle} (
                                                                                            <span className={(showChanges && modifiedValues?.total_taxes?.montants_details?.find(m => m._id == montant._id)) ? "modified-bg" : ""}>
                                                                                                {currencyFormat(montant.montant)} {parametres?.general?.devise_dossier}
                                                                                            </span>
                                                                                            )</p>
                                                                                    ))}
                                                                                </div>
                                                                            }

                                                                            {currentBrouillon.total_ttc != null &&
                                                                                <h6 className="mt-3">
                                                                                    TOTAL TTC
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.total_ttc) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.total_ttc)} {parametres?.general?.devise_dossier}
                                                                                    </span>
                                                                                </h6>

                                                                            }

                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        <Col lg={currentBrouillon?.type == "proforma" ? { span: 6 } : null} xxl={currentBrouillon?.type == "proforma" ? { span: 4 } : null} className="bg-primary-600 text-white">
                                                            <div className="p-3">
                                                                <h6 className="d-flex align-items-center mb-2"><i className="me-1 fs-4 material-icons">bar_chart</i>Synthèse prix</h6>
                                                                <div className="d-flex flex-column">
                                                                    {currentBrouillon.details.length == 0 &&
                                                                        <em>- Aucun total à afficher -</em>
                                                                    }
                                                                    {currentBrouillon.details.length > 0 &&
                                                                        <div className="">

                                                                            {(currentBrouillon.details.length > 0 && currentBrouillon.total_prix_revient != null) &&
                                                                                <p className="m-0 d-inline-block w-100">
                                                                                    Total prix de revient
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.total_prix_revient) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.total_prix_revient)} {parametres?.general?.devise_dossier}
                                                                                    </span>
                                                                                </p>
                                                                            }

                                                                            {(currentBrouillon.details.length > 0 && currentBrouillon.taux_marge_global_calc != null) &&
                                                                                <p className="m-0 d-inline-block w-100">
                                                                                    Taux de marge global
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.taux_marge_global_calc) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.taux_marge_global_calc)} %
                                                                                    </span>
                                                                                </p>
                                                                            }
                                                                            {(currentBrouillon.details.length > 0 && currentBrouillon.taux_marque_global_calc != null) &&
                                                                                <p className="m-0 d-inline-block w-100">
                                                                                    Taux de marque global
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.taux_marque_global_calc) ? "modified-bg" : "")}>
                                                                                        {currentBrouillon.taux_marque_global_calc} %
                                                                                    </span>
                                                                                </p>
                                                                            }
                                                                            {(currentBrouillon.details.length > 0 && currentBrouillon.coefficient_global_calc != null) &&
                                                                                <p className="m-0 d-inline-block w-100">
                                                                                    Coefficient global
                                                                                    <span className={"float-end " + ((showChanges && modifiedValues?.coefficient_global_calc) ? "modified-bg" : "")}>
                                                                                        {currencyFormat(currentBrouillon.coefficient_global_calc)} {parametres?.general?.devise_dossier}
                                                                                    </span>
                                                                                </p>
                                                                            }

                                                                        </div>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </Col>

                                                        {(currentBrouillon?.type == "facture" || currentBrouillon?.type == "avoir") &&
                                                            <Col lg="4" className="bg-primary-500 text-white">
                                                                <div className="p-3">
                                                                    <Reglements brouillon={currentBrouillon} reloadBrouillon={getBrouillon} showChanges={showChanges} modifiedValues={modifiedValues} />
                                                                </div>
                                                            </Col>
                                                        }

                                                        {currentBrouillon?.type == "abonnement" &&
                                                            <Col lg="4" className="bg-primary-500 text-white">
                                                                <div className="p-3">
                                                                    <Scheduled brouillon={currentBrouillon} setIsComponentEditing={value => setIsScheduledEditing(value)} changeValue={handleChange} showChanges={showChanges} modifiedValues={modifiedValues} />
                                                                </div>
                                                            </Col>
                                                        }

                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>

                            </Row>

                            {/* Zone details */}
                            <Row>
                                <Col xs={12}>
                                    <div className="rounded border p-3">
                                        <h6 className="text-dark d-flex align-items-center mb-2"><i className="text-primary-600 me-1 fs-4 material-icons">manage_search</i>Détails</h6>
                                        <Description brouillon={currentBrouillon} changeValue={handleChange} invalidData={invalidData?.description} showChanges={showChanges} modifiedValues={modifiedValues} />
                                        <DetailsTable folderId={folderDetails?.dossier?._id} openArticleId={id => setArticleDetailOpenId(id)} brouillon={currentBrouillon} setIsComponentEditing={value => setIsDetailsEditing(value)} showChanges={showChanges} modifiedValues={modifiedValues} reloadBrouillon={getBrouillon} getBrouillonLoading={getBrouillonLoading} /* setLastAddedDetailId={id => setLastAddedDetailId(id)} */ dropBottom={!isAccordeonOpen && currentBrouillon.details.length < 8} />
                                    </div>

                                </Col>
                            </Row>
                        </Container>
                    }
                </>
            </div>
        </>
    );
}